import {Request} from '../utilities/Request';

export function loadCustomJob(this_obj) {
  return Request.get(
    this_obj,
    '/api/jobs/custom_job',
    null
  );
}
